import { z } from 'zod';

export const ListCodesItemSchema = z.object({
  categoryCode: z.string(),
  codeDesc: z.string(),
  codeId: z.string(),
  createdBy: z.string().nullable(),
  createdDate: z.string().refine(
    (val) => {
      return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{1,3})?$/.test(val);
    },
    {
      message: 'Invalid date format (expected YYYY-MM-DDTHH:mm:ss(.SSS)?)',
    }
  ),
  id: z.string(),
  isValid: z.boolean(),
  lastModifiedBy: z.string().nullable(),
  lastModifiedDate: z.string().refine(
    (val) => {
      return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{1,3})?$/.test(val);
    },
    {
      message: 'Invalid date format (expected YYYY-MM-DDTHH:mm:ss(.SSS)?)',
    }
  ),
});

export const ListCodesSchema = z.array(ListCodesItemSchema);
